import React, { useEffect, useState } from "react";
import axios from "../../axios";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import "./dashboard.scss";

const AwaitingDiscussions = () => {
  const [newcase, setnewcase] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showMore, setShowMore] = useState(false);
  // pagination
  const [pageNumber, setPageNumber] = useState(0);
  const productsPerPage = 6;
  const productsPerList = 50;
  const pagesVisited = pageNumber * productsPerPage;
  let displayawaitingdiscussion = [];
  const pageCount = Math.ceil(filtered.length / productsPerPage);

  const changePage = ({ selected }) => {
    // console.log(selected);
    setPageNumber(selected);
  };

  useEffect(() => {
    axios
      .get("report-cases/caseFromUser/" + window.localStorage.getItem("id"))
      .then((res) => {
        setnewcase(res?.data);
        setFiltered(res?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <>
      <div className="row">
        {
          (displayawaitingdiscussion = filtered
            ?.slice(pagesVisited, pagesVisited + productsPerPage)
            ?.map((el) => {
              return (
                <div className="new-case" key={el.id}>
                  <div className="row case">
                    <b>Case:</b>
                    {el.case_al?.length >= 60 ?
                      <span>
                        {showMore ? el.case_al : el.case_al?.slice(0, 60) + "..."}
                        <a className="btn" onClick={() => setShowMore(!showMore)}>{showMore ? "Show less" : "Show more"}</a>
                      </span> : <span>{el.case_al}</span>}
                  </div>
                  <div className="row type">
                    <b>Report Type:</b> {el.name_al}
                  </div>
                  <div className="row municipality">
                    <b>Municipality:</b> {el.municipality_al}
                  </div>
                  <div className="row agency">
                    <b>Agency:</b> {el.gov_al}
                  </div>
                  <div className="row contact">
                    <b>Contact:</b> {el.phone}
                  </div>
                  <div className="row contact">
                    <b>Email:</b> {el.email}
                  </div>
                  {/* <div className="row actions ">
                    <button className="publish">Publish</button>
                    <button className="translate">Translate</button>
                    <button className="delete">Delete</button>
                  </div> */}
                  <div className="row actions ">
                    {/* <button className="publish">Publish</button> */}
                    <Link to={"/report-cases/" + el.id}>
                      {" "}
                      <button className="translate">Discussion</button>
                    </Link>

                    {/* <button className="delete">Delete</button> */}
                  </div>
                </div>
              );
            }))
        }
      </div>
      <div className="row mt-5">
        <div className="col-12">
          {newcase.length >= productsPerPage ? (
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              pageCount={pageCount}
              onPageChange={changePage}
              containerClassName={"paginationBttns"}
              previousLinkClassName={"previousBttn"}
              nextLinkClassName={"nextBttn"}
              disabledClassName={"paginationDisabled"}
              activeClassName={"paginationActive"}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default AwaitingDiscussions;
